import { assertNever, capitalCase } from '@common/neo.tax';

import { UnsavedChangesScenario } from './alert-modal.types';

export const getTitleText = (scenario: UnsavedChangesScenario, description?: string): string => {
  switch (scenario) {
    case 'change-selection':
      return capitalCase(`Change ${description} Selection?`);
    case 'close-drawer':
      return 'Close Drawer?';
    case 'leave-tab':
      return capitalCase(`Leave ${description} Tab?`);
    default:
      assertNever(scenario);
  }
};

export const getCopyText = (scenario: UnsavedChangesScenario, description?: string): string => {
  let phrase = '';

  switch (scenario) {
    case 'change-selection':
      phrase = `change your ${description} selection`;
      break;
    case 'close-drawer':
      phrase = 'close the current drawer';
      break;
    case 'leave-tab':
      phrase = `leave the current tab on ${description}`;
      break;
    default:
      assertNever(scenario);
  }

  return `Are you sure you want to ${phrase}? The changes you made won't be saved. This action cannot be undone.`;
};

export const getConfirmButtonText = (scenario: UnsavedChangesScenario): string => {
  switch (scenario) {
    case 'change-selection':
      return 'Change Selection';
    case 'close-drawer':
      return 'Close Drawer';
    case 'leave-tab':
      return 'Leave Tab';
    default:
      assertNever(scenario);
  }
};

export const getCancelButtonText = (scenario: UnsavedChangesScenario): string => {
  switch (scenario) {
    case 'change-selection':
      return "Don't Change";
    case 'close-drawer':
      return "Don't Close";
    case 'leave-tab':
      return "Don't Leave";
    default:
      assertNever(scenario);
  }
};
